module.exports = __webpack_public_path__ + "img/top_pain.d6f4ca76.gif";